<template>
  <div class="card card-custom">
    <div class="card-header py-3">
      <div class="card-title align-items-start flex-column">
        <h3 class="card-label font-weight-bolder text-dark">Personal Information</h3>
        <span class="text-muted font-weight-bold font-size-sm mt-1">Update your personal information.</span>
      </div>
    </div>

    <div class="card-body">
      <!-- begin::Form -->
      <form class="form">
        <personal-information-form
          ref="personalInformationForm"

          :document="document"

          action="EDIT"
          :disabled="isLoadingForm"
        />

        <div class="d-flex justify-content-between border-top pt-10">
          <button class="btn btn-success font-weight-bold text-uppercase px-9 py-4 ml-auto" @click.prevent="submitForm">
            Save
          </button>
        </div>
      </form>
      <!-- end::Form -->
    </div>
  </div>
</template>

<script>
import User from '@/libs/classes/user';
import { validations, mutations as mutationsLib } from '@vedicium/core-vue';
import personalInformationForm from './components/personal-information.form.vue';

export default {
  props: {
    resource: {
      type: User,
      default: null,
    },
  },
  components: {
    personalInformationForm,
  },
  data () {
    return {
      isLoadingForm: false,

      document: (this.resource ? this.resource.clone() : null),
    };
  },

  methods: {
    async validate () {
      const validationArray = [this.$refs.personalInformationForm.$v];

      await validations.validateArray(validationArray);
    },
    async submitForm () {
      this.$errors.clear({ component: this });
      this.$set(this, 'isLoadingForm', true);

      try {
        await this.validate();

        const mutations = mutationsLib.create(['firstname', 'lastname', 'email'], this.resource.formatBody('update'), this.document.formatBody('update'));
        if (mutations.length > 0) {
          const response = await this.$ws.patch(`${User.uri}/me`, { body: mutations });
          this.resource.merge(response);
          this.$set(this, 'document', this.resource.clone());
        }
      } catch (e) {
        console.error(e);
        this.$errors.handle(e, { component: this });
        return;
      } finally {
        this.$set(this, 'isLoadingForm', false);
      }
    },
  },
};
</script>
